/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2018, Zumper
 * @description ExternalIcon
 */

import { WHITE } from '@zcode/nr/es/shared/constants/color'
import PropTypes from 'prop-types'
import React from 'react'

const ExternalIcon = ({ className, color }) => (
  <svg className={className} fill="none" height={21} viewBox="0 0 19 21" width={19}>
    <path
      clipRule="evenodd"
      d="M17.374.983a1 1 0 0 1 1 1v4.779a1 1 0 1 1-2 0V4.576l-6.169 6.168a1.126 1.126 0 0 1-1.593-1.593l6.169-6.168h-2.186a1 1 0 1 1 0-2h4.779zM7.76 3.713a1.126 1.126 0 1 1 0 2.252H3.254V17.23h11.262v-5.633a1.126 1.126 0 0 1 2.253 0v6.711l.001.048c0 .622-.504 1.127-1.126 1.127H2.126a1.126 1.126 0 0 1-1.125-1.167V4.84c0-.622.504-1.127 1.126-1.127h5.634z"
      fill={color ?? WHITE}
      fillRule="evenodd"
    />
  </svg>
)

ExternalIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
}

export default ExternalIcon
